export enum WidocznoscPolaNaOswiadczeniu {
  niewidoczne,
  widoczneTylkoNaOswiadczeniu,
  widoczneNaOswiadczeniuIProjekcie,
}
